'use strict';

angular.module('actionPlanModule', [
    'services.authenticatedUser',
    'recommendationModule'
]);